/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * 
 * @export
 * @interface InternalApiCreateAlertNoteTemplateRequest
 */
export interface InternalApiCreateAlertNoteTemplateRequest {
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiCreateAlertNoteTemplateRequest
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateAlertNoteTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateAlertNoteTemplateRequest
     */
    content: string;
}



/**
 * Check if a given object implements the InternalApiCreateAlertNoteTemplateRequest interface.
 */
export function instanceOfInternalApiCreateAlertNoteTemplateRequest(value: object): value is InternalApiCreateAlertNoteTemplateRequest {
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCreateAlertNoteTemplateRequestFromJSON(json: any): InternalApiCreateAlertNoteTemplateRequest {
    return InternalApiCreateAlertNoteTemplateRequestFromJSONTyped(json, false);
}

export function InternalApiCreateAlertNoteTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateAlertNoteTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'name': json['name'],
        'content': json['content'],
    };
}

export function InternalApiCreateAlertNoteTemplateRequestToJSON(json: any): InternalApiCreateAlertNoteTemplateRequest {
    return InternalApiCreateAlertNoteTemplateRequestToJSONTyped(json, false);
}

export function InternalApiCreateAlertNoteTemplateRequestToJSONTyped(value?: InternalApiCreateAlertNoteTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'name': value['name'],
        'content': value['content'],
    };
}

